/*
  Tesettür Paris — "Daha fazla göster".
  Sonsuz kaydırma yok: ziyaretçi isteyince bir sonraki sayfa çekilir ve mevcut ızgaraya eklenir.
  JS çalışmazsa bağlantı olduğu gibi sonraki sayfaya gider — işlev kaybolmaz.
  Yeni kütüphane yok; temanın custom element düzeni izlendi.
*/
class TpDahaFazla extends HTMLElement {
  connectedCallback() {
    this.buton = this.querySelector('.tp-daha-fazla__buton');
    this.sayac = this.querySelector('.tp-daha-fazla__sayac');
    if (!this.buton) return;
    this.buton.addEventListener('click', (e) => this.getir(e));
  }

  async getir(olay) {
    olay.preventDefault();
    const adres = this.buton.getAttribute('href');
    if (!adres || this.yukleniyor) return;

    this.yukleniyor = true;
    this.classList.add('tp-daha-fazla--yukleniyor');
    this.buton.setAttribute('aria-busy', 'true');

    try {
      const yanit = await fetch(adres);
      if (!yanit.ok) throw new Error(yanit.status);
      const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');

      const izgara = document.getElementById(this.dataset.hedef);
      const yeniIzgara = belge.getElementById(this.dataset.hedef);
      if (!izgara || !yeniIzgara) throw new Error('ızgara bulunamadı');

      const yeniler = [...yeniIzgara.children];
      const ilkYeni = yeniler[0];
      yeniler.forEach((o) => izgara.appendChild(o));

      /* Sonraki sayfanın bağlantısı: yoksa düğme tamamen kalkar */
      const sonraki = belge.querySelector('tp-daha-fazla .tp-daha-fazla__buton');
      if (sonraki) {
        this.buton.setAttribute('href', sonraki.getAttribute('href'));
      } else {
        this.buton.remove();
      }

      this.sayacGuncelle(izgara.children.length, belge);

      /* Klavye kullanıcısı eklenen ilk ürüne düşsün, başa fırlamasın */
      if (ilkYeni) {
        const odak = ilkYeni.querySelector('a');
        if (odak) {
          odak.setAttribute('tabindex', '-1');
          odak.focus({ preventScroll: true });
        }
      }
    } catch (e) {
      /* Hata halinde düğme normal bağlantıya döner: tıklayan sonraki sayfaya gider */
      this.buton.removeEventListener('click', this.getir);
      window.location.href = adres;
    } finally {
      this.yukleniyor = false;
      this.classList.remove('tp-daha-fazla--yukleniyor');
      this.buton?.removeAttribute('aria-busy');
    }
  }

  sayacGuncelle(gosterilen, belge) {
    if (!this.sayac) return;
    const kaynak = belge.querySelector('tp-daha-fazla .tp-daha-fazla__sayac');
    /* Metin şablonu sunucudan gelir; yalnızca "gösterilen" sayısı yerelde güncellenir */
    const sablon = kaynak ? kaynak.textContent : this.sayac.textContent;
    this.sayac.textContent = sablon.replace(/\d+/, String(gosterilen));
  }
}

customElements.define('tp-daha-fazla', TpDahaFazla);
